/*!
 * jQuery lightweight plugin boilerplate
 * Original author: @ajpiano
 * Further changes, comments: @addyosmani
 * Licensed under the MIT license
 */


;(function ( $, window, document, undefined ) {

    var pluginName = 'beTable',
        defaults = {
            dataset: {
                ajax: true,
                ajaxUrl: window.location.origin + '/company/list',

                ajaxOnLoad: true,
                records: []
            },
            inputs: {
                processingText : "<div id='processingIndicator'> " +
                "<div class='loader'> " +
                "<svg class='circular'> " +
                "<circle class='path' cx='50' cy='50' r='20' fill='none' stroke-width='5' stroke-miterlimit='10'></circle> </svg>" +
                "</div></div>"
            },
            features : {
                search : false
            },
            params : {
                dynatable: 'dynatable',
                queries: 'queries',
                sorts: 'sorts',
                page: 'page',
                perPage: 'perPage',
                offset: 'offset',
                records: 'data',
                record: null,
                queryRecordCount: 'total',
                totalRecordCount: 'current_page'
            }
        };

    // The actual plugin constructor
    function Plugin( element, options ) {
        this.element = element;

        this.options = $.extend( true, defaults, options) ;

        this._defaults = defaults;
        this._name = pluginName;

        this.$dynatable = $(this.element).dynatable(this.options).data('dynatable');

        this.init();
    }

    Plugin.prototype.init = function () {
        var Plugin = this;

        setTimeout(function () {
            Plugin.setEvents();
        }, 2000)
    };

    Plugin.prototype.setEvents = function(){
        var Plugin = this;

        $(Plugin.element).bind('dynatable:afterUpdate', function(e, dynatable){
            $('[data-toggle="tooltip"]').tooltip();
        });

        $('.js-filter :input').on('change',function(){
            var value = $(this).val();
            var queriesBeforeModify = JSON.stringify(Plugin.$dynatable.settings.dataset.queries);

            if (value) {
                Plugin.$dynatable.queries.add($(this).attr('name'),value);
            } else {
                Plugin.$dynatable.queries.remove($(this).attr('name'));
            }

            var queriesAfterModify = JSON.stringify(Plugin.$dynatable.settings.dataset.queries);

            if(queriesBeforeModify !== queriesAfterModify) {
              if(!$(this).parents('.js-filter-manual').length) {
                Plugin.$dynatable.process();
              }
            }
        });

        $('.js-export-students').on('click', function() {
            $('select[name="mailable"]').val('1').trigger('change.select2');
            Plugin.$dynatable.queries.add('mailable', 1);
            Plugin.$dynatable.queries.add('export', 1);
        });

        $('.js-export-companies').on('click', function() {
          Plugin.$dynatable.queries.add('export', 1);
        });

        $('.js-search').on('click', function() {
            Plugin.$dynatable.process();
            Plugin.$dynatable.queries.remove('export');
        });


        $(Plugin.element).on('dataChanged', function(){
            Plugin.$dynatable.process();
        })
    };


  $.dynatableSetup({
    writers: {
      _attributeWriter: function(record, trusted) {
        if (trusted) {
          return record[this.id];
        } else {
          return $('<div />').html(record[this.id]).text();
        }
      },
      _cellWriter: function (column, record) {
        var trusted = false;
        var trustedColumns = ['icons', 'actions', 'cv', 'edit', 'more', 'status', 'validate', 'cheked', 'ascribed_to',  'university_name',
        'agreement_name', 'student_name', 'company_name', 'job_offer_name', 'landing_name', 'admin_user', 'unlocked_services', 'invoice_buttons', 'linkView','url', 'active',
        'quotes', 'news', 'orders', 'nombre', 'contactoDeFacturación', 'estado', 'editar', 'messages', 'partnerName', 'is_filterable', 'is_verifiable']

        if (trustedColumns.indexOf(column.id) !== -1) trusted = true;
        var html = column.attributeWriter(record, trusted),
          td = '<td';

        if (column.hidden || column.textAlign) {
          td += ' style="';

          // keep cells for hidden column headers hidden
          if (column.hidden) {
            td += 'display: none;';
          }

          // keep cells aligned as their column headers are aligned
          if (column.textAlign) {
            td += 'text-align: ' + column.textAlign + ';';
          }

          td += '"';
        }

        return td + '>' + html + '</td>';
      }
    }
  });
    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                    new Plugin( this, options ));
            }
        });
    }

})( jQuery, window, document );
